import axios from "axios";
import { API_URL } from "./index";
class ReportService {
    sendAdvReport = (payload) => {
        return axios.post(API_URL.report("adv-send-email"), payload).then((response) => response.data);
    };
}

export default new ReportService();
